import React from 'react'
import { Tooltip, Button } from 'antd'

const TooltipButton = ({ tooltip, ...remainingProps }) => (
  <Tooltip title={tooltip}>
    <Button type="link" {...remainingProps} />
  </Tooltip>
)
export default TooltipButton
